"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApplyNoteToSessionDropdown = void 0;
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _components = require("../../../../components");
var _utils = require("../../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ApplyNoteToSessionDropdown = function ApplyNoteToSessionDropdown(_ref) {
  var patientId = _ref.patientId,
    note = _ref.note,
    value = _ref.value,
    disabled = _ref.disabled,
    onChange = _ref.onChange;
  var dropdownId = (0, _utils.useUniqueHtmlId)();
  var _useRequest = (0, _utils.useRequest)((0, _utils.getBookingsForNoteUrl)(patientId), {
      formatResult: function formatResult(bookings) {
        if (note.bookingId && !(0, _lodash.find)(bookings, {
          id: note.bookingId
        })) {
          bookings.push({
            id: note.bookingId,
            startsAt: note.startsAt
          });
          return (0, _lodash.sortBy)(bookings, 'startsAt');
        }
        return bookings;
      }
    }),
    _useRequest$data = _useRequest.data,
    patientBookings = _useRequest$data === void 0 ? [] : _useRequest$data;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: dropdownId,
    className: "text-black mb-[8px] block"
  }, "Associated session"), /*#__PURE__*/_react.default.createElement(_components.Dropdown, {
    id: dropdownId,
    placeholder: "Select a session",
    className: "w-full",
    value: value,
    onChange: onChange,
    disabled: disabled
  }, patientBookings.map(function (booking) {
    return /*#__PURE__*/_react.default.createElement(_components.Dropdown.Option, {
      value: booking.id,
      key: booking.id
    }, (0, _momentTimezone.default)(booking.startsAt).format('llll'));
  })));
};
exports.ApplyNoteToSessionDropdown = ApplyNoteToSessionDropdown;